// extracted by mini-css-extract-plugin
export default {"divMessage":"PageNotFound_divMessage__H0fVc","btnHome":"PageNotFound_btnHome__luT6M"};